import HistoryOutlinedIcon from '@ant-design/icons/HistoryOutlined'

import IconButton from '@mui/material/IconButton'

import usePopover from '@shared/hooks/src/usePopover'

import { PagesHistoryPopover } from '@pages/PagesHistory'

export default function PagesHistory({ size }) {
  const popover = usePopover()

  return (
    <>
      <IconButton
        id="pages-history-button"
        color="secondary"
        size={size}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        aria-label="Pages History"
        data-testid="header-pages-history"
      >
        <HistoryOutlinedIcon style={{ fontSize: 18 }} />
      </IconButton>
      <PagesHistoryPopover anchorEl={popover.anchorRef.current} onClose={popover.handleClose} open={popover.open} />
    </>
  )
}
